<!-- TODO: MERGE INTO ONE COMPONENT -->
<div class="top-margin d-flex fd-row flex-wrap jc-start ai-stretch">
  <h4 class="margin">Your Billing Details</h4>
</div>

<div class="d-flex fd-row flex-wrap jc-start ai-stretch">

  <div class="margin card flex-1 d-flex fd-row ai-stretch">

    <div class="padding" style="flex: 0 1 40%" class="d-flex fd-col jc-start ai-stretch">
      <p>We use <b><a>Stripe™</a></b> to manage your payment methods.</p>
      <br>

    </div>

    <mat-divider [vertical]="true"></mat-divider>

    <div class="padding" style="flex: 0 1 60%" class="d-flex fd-col jc-start ai-stretch">
      <p>To manage your existing payment methods, click the button to go to the Stripe™ Customer Portal.</p>

      <button button mat-flat-button color="primary" class="billing-portal-btn" (click)="goToCustomerPortal()">
        <mat-icon>link</mat-icon>
        Manage Billing Details
      </button>
    </div>


  </div>

</div>
